// =============================================================================
// features/sales/campaigns/detail/CampaignDetailTabs.tsx — Navegação das 5
// abas do painel. Scroll horizontal com snap no mobile (mesmo padrão de
// CampaignsIndicators.tsx) — DoD do slot: "abas viram navegação utilizável,
// não fileira comprimida", nunca 5 pills espremidas sem rolagem.
// =============================================================================

import * as React from 'react';

import { cn } from '../../../../lib/cn';

import { DETAIL_TAB_IDS, DETAIL_TAB_LABEL } from './useDetailTab';
import type { DetailTabId } from './useDetailTab';

export interface CampaignDetailTabsProps {
  active: DetailTabId;
  onChange: (tab: DetailTabId) => void;
}

export function CampaignDetailTabs({
  active,
  onChange,
}: CampaignDetailTabsProps): React.JSX.Element {
  return (
    <div
      role="tablist"
      aria-label="Seções da campanha"
      className="flex gap-1 overflow-x-auto snap-x pb-1 border-b border-border-subtle"
    >
      {DETAIL_TAB_IDS.map((id) => {
        const isActive = id === active;
        return (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(id)}
            className={cn(
              'snap-start shrink-0 min-h-[44px] px-4 font-sans text-sm font-medium',
              'transition-colors duration-fast border-b-2 -mb-px',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-azul/20 rounded-t-sm',
              isActive
                ? 'border-azul text-ink'
                : 'border-transparent text-ink-3 hover:text-ink-2 hover:border-border-strong',
            )}
          >
            {DETAIL_TAB_LABEL[id]}
          </button>
        );
      })}
    </div>
  );
}
